<template>
  <div>
   
    <autoLogout />
    <loader :loader="sending" />
    <div class="wrapper-content">
      <encabezado :elementos="encabezado" />
      <v-card>
        <v-card-text>
          <v-container>
            <v-row align="baseline" justify="center" class="text-center pb-4">
              <v-col cols="12" md="9" xl="10">
                <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Buscar"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      block
                      v-bind="attrs"
                      v-on="on"
                      @click="$router.push('/configuracion/agregar/rol')"
                    >
                      <v-icon left>mdi-account-key</v-icon>Nuevo rol
                    </v-btn>
                  </template>
                  <span>Agregar rol</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-data-table
              :headers="headers"
              :items="list"
              :search="search"
              :items-per-page="10"
              :footer-props="{
                'items-per-page-text': 'Elementos por página',
                'items-per-page-all-text': 'Todo',
              }"
              no-results-text="Sin resultados coincidentes con la búsqueda"
              loading-text="Cargando..."
              no-data-text="Sin resultados disponibles"
              dense
              fixed-header
              height="auto"
            >
              <template v-slot:[`item.status`]="{ item }">
                <v-btn
                  icon
                  @click.native.prevent.stop.capture="editarStatus(item)"
                >
                  <v-switch v-model="item.status" color="success" ></v-switch>
                </v-btn>
              </template>
              <template v-slot:[`item.actions`]="{ item }">
                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon @click="checkDetail(item)" x-small>
                      <v-icon color="blue" v-bind="attrs" v-on="on">
                        mdi-pencil
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Editar permisos del rol</span>
                </v-tooltip>

                <v-tooltip top>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon x-small @click="showModalRole(item)">
                      <v-icon color="yellow" v-bind="attrs" v-on="on">
                        far fa-copy
                      </v-icon>
                    </v-btn>
                  </template>
                  <span>Duplicar Rol</span>
                </v-tooltip>
              </template>
            </v-data-table>
          </v-container>
        </v-card-text>

        <v-card-actions class="text-center">
          <v-col>
            <export-import-btn
              texto="Importar roles"
              icono="import"
              color="secondary"
              @accion="askFileImport()"
            />
          </v-col>
          <v-col>
            <export-import-btn
              texto="Exportar roles"
              icono="export"
              color="green darken-1"
              @accion="exportRoles()"
            />
          </v-col>
        </v-card-actions>
      </v-card>

      <!-- DIALOGS -->
      <v-dialog v-model="dialog" persistent max-width="450">
        <v-card>
          <v-card-title class="text-h6 text-center">
            ¿Desea modificar el estatus?
          </v-card-title>
          <v-card-text
            >El rol será Habilitado / Inhabilitado de inmediato, lo que podría
            afectar a los usuarios que dependan del mismo</v-card-text
          >
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="dialog = false"> Cancelar </v-btn>
            <v-btn
              color="primary"
              text
              @click="
                dialog = false;
                changeStatus(dataModal);
              "
            >
              Aceptar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="importDialog" max-width="450">
        <v-card>
          <v-card-title class="text-h6 text-center">
            Importar roles
          </v-card-title>
          <v-card-text>
            <v-file-input
              accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,text/comma-separated-values, text/csv, application/csv"
              label="Cargar archivo"
              placeholder="Seleccione un archivo"
              v-model="fileXls"
            ></v-file-input>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click="importDialog = false">
              Cancelar
            </v-btn>
            <v-btn
              color="primary"
              text
              @click="importRoles()"
              :disabled="!fileXls"
            >
              Cargar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="updateModal" max-width="450">
        <v-card>
          <v-card-title>
            <v-row>
              <v-col class="text-center">
                <h1>Roles</h1>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row class="d-flex flex-column" justify="center" align="center">
              <v-col
                class="text-center font-weight-bold title"
                :class="results.done ? 'success--text' : 'error--text'"
              >
                {{
                  results.done
                    ? "Registros cargados correctamente"
                    : "Sucedio un error al cargar los registros"
                }}
              </v-col>
              <v-col>
                <h2 class="font-weight-black">
                  <v-icon color="success" left>mdi-check-circle</v-icon>Nuevos:
                  {{ results.news }}
                </h2>
              </v-col>
              <v-col>
                <h2 class="font-weight-black">
                  <v-icon color="warning" left>mdi-circle-edit-outline</v-icon
                  >Modificados: {{ results.updates }}
                </h2>
              </v-col>
              <v-col>
                <h2 class="font-weight-black">
                  <v-icon color="error" left>mdi-alert-circle</v-icon>Errores:
                  <ul>
                    <li
                      v-for="(error, index) in results.errors"
                      :key="index"
                      class="my-3"
                    >
                      <v-icon color="warning" left>mdi-exclamation</v-icon>Error
                      {{ index + 1 }}: {{ error }}
                    </li>
                  </ul>
                </h2>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-col class="text-center">
              <v-btn text color="error" @click="updateModal = !updateModal"
                >Cerrar</v-btn
              >
            </v-col>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="showDialogRole" max-width="750">
        <v-card>
          <v-card-title>
            <v-row class="mb-3">
              <v-col class="text-center">
                <h2>Agregar rol</h2>
              </v-col>
            </v-row>
          </v-card-title>
          <validation-observer ref="observer" v-slot="{ invalid }">
            <v-card-text>
              <v-row
                class="d-flex flex-column mb-2"
                justify="center"
                align="center"
              >
                <v-col>
                  <h3 class="font-weight-black">
                    <v-icon color="grey" left>fas fa-user-tie</v-icon>Rol a
                    duplicar:
                    {{ roleToDuplicate.name }}
                  </h3>
                </v-col>
                <v-col>
                  <h3 class="font-weight-black">
                    <v-icon color="warning" left>fas fa-clipboard-list</v-icon
                    >Cantidad de permisos: {{ roleToDuplicate.permissions }}
                  </h3>
                </v-col>
              </v-row>

              <v-row>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Nombre"
                    rules="required"
                  >
                    <v-text-field
                      v-model="newRole.roleName"
                      :error-messages="errors"
                      label="Nombre*"
                      required
                      autocomplete="off"
                    >
                    </v-text-field>
                  </validation-provider>
                </v-col>
                <v-col>
                  <validation-provider
                    v-slot="{ errors }"
                    name="Descripción"
                    rules="required"
                  >
                    <v-textarea
                      v-model="newRole.description"
                      :error-messages="errors"
                      rows="2"
                      label="Descripción*"
                      required
                      autocomplete="off"
                    >
                    </v-textarea>
                  </validation-provider>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-col class="text-center">
                <v-btn
                  text
                  color="error"
                  @click="showDialogRole = false"
                  :disabled="sending"
                  >Cerrar<v-icon right>mdi-close</v-icon></v-btn
                >
                <v-btn
                  text
                  color="success"
                  @click="duplicateRole()"
                  :disabled="sending || invalid"
                  >{{ sending ? "Duplicando..." : "Duplicar"
                  }}<v-icon right>far fa-copy</v-icon></v-btn
                >
              </v-col>
            </v-card-actions>
          </validation-observer>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import Datatable from "../../components/Datatable.vue";
import Encabezado from "@/app/components/base/header/Header.vue";
import Sidebar from "../../components/Sidebar";
import BtnAccion from "../../components/btnAccion.vue";
import { RolePermissionRequest, ReportPDFRequest } from "@/core/request";
import { mapActions } from "vuex";
import AutoLogout from "../../components/AutoLogout.vue";
import ExportImportBtn from "../../components/ExportImportBtn.vue";
import UploadDialog from "../../components/UploadDialog.vue";
import Loader from "../../components/Loader.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";

export default {
  name: "Estudio",
  components: {
    Sidebar,
    Encabezado,
    Datatable,
    BtnAccion,
    AutoLogout,
    ExportImportBtn,
    UploadDialog,
    Loader,
    ValidationProvider,
    ValidationObserver,
  },
  data: () => ({
    dialog: false,
    importDialog: false,
    updateModal: false,
    search: "",
    dataModal: "",
    encabezado: { icono: "mdi-account-key", texto: "Roles y permisos" },
    list: [],
    //icono: { icon: "mdi-play", color: "success", tooltip: "Comenzar estudio" },
    headers: [
      { text: "ID Rol", value: "idRole", align: "center" },
      { text: "Nombre Rol", value: "name", align: "center" },
      { text: "Descripción del Rol", value: "description", align: "center" },
      { text: "Número de permisos", value: "permissions", align: "center" },
      { text: "Estatus", value: "status", align: "center" },
      { text: "Acciones", value: "actions", sortable: false, align: "center" },
    ],
    btnRole: {
      route: "/configuracion/agregar/rol",
      icon: "mdi-account-multiple-plus",
      text: "Agregar Rol",
      tooltip: "Agregar Rol",
    },
    service: RolePermissionRequest,
    fileXls: null,
    results: {},
    sending: false,
    showDialogRole: false,
    roleToDuplicate: {},
    newRole: {},
  }),
  mounted() {
    this.validBrowserTab();
    this.listAll();
  },
  methods: {
    ...mapActions(["validTab", "unauthorized"]),
    validBrowserTab() {
      this.validTab();
    },
    catchError: (e) => {
      //console.log(e);
      this.$utilFront.notifications("Ha ocurrido un error interno", "ERROR");
    },
    listAll() {
      RolePermissionRequest.listAllRoles().then((res) => {
        if (res.data.code === 200 && res.data.status === "OK") {
          this.list = res.data.data.map((role) => {
            return role;
          });
        } else if (res.data.code === 401) {
          this.unauthorized();
        }
      });
    },
    checkDetail(item) {
      localStorage.setItem("idRole", item.idRole);
      this.$router.push("/configuracion/roles-permisos");
    },
    editarStatus(item) {
      this.dialog = true;
      this.dataModal = Object.assign(this.dataModal, item);
    },
    changeStatus(item) {
      if(!this.sending){
      this.sending = true;
      let post = {
        idRole: item.idRole,
      };
      RolePermissionRequest.statusRole(post).then((res) => {
        if (res.data.data) {
          if (res.data.code === 200 && res.data.status === "OK") {
            this.list.forEach((element) => {
              if (element.idRole == this.dataModal.idRole) {
                element.status = this.dataModal.status == 0 ? 1 : 0;
              }
            });
            this.$utilFront.notifications(
              "Estatus del rol modificado correctamente",
              "SUCCESS"
            );
          } else if (res.data.code === 401) {
            this.unauthorized();
          } else {
            this.$utilFront.notifications(
              "Sucedio un error al cambiar el estatus del rol",
              "ERROR"
            );
          }
        }
        this.sending = false;
      });
      }
    },
    askFileImport() {
      this.importDialog = !this.importDialog;
    },
    importRoles() {
      this.importDialog = !this.importDialog;

      if (this.fileXls) {
        this.sending = true;

        let formData = new FormData();

        formData.append("file", this.fileXls);

        ReportPDFRequest.importTempleteRole(formData)
          .then((res) => {
            res.data.text().then((texto) => {
              const { done, errors, news, updates } = JSON.parse(texto).data;

              this.results = JSON.parse(texto).data;

              if (done) {
                this.fileXls = null;
                this.listAll();
              }
              this.updateModal = true;
            });
          })
          .finally(() => {
            this.sending = false;
          });
      }
    },
    exportRoles() {
      this.sending = true;
      ReportPDFRequest.exportTempleteRole()
        .then((res) => {
          const url = URL.createObjectURL(
            new Blob([res.data], {
              type: "application/vnd.ms-excel",
            })
          );

          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Roles.xlsx");
          document.body.appendChild(link);
          link.click();
        })
        .finally(() => {
          this.sending = false;
        });
    },

    duplicateRole() {
      if(!this.sending){
      try {
        this.sending = true;
        let post = {
          idRoleToDuplicate: this.roleToDuplicate.idRole,
          roleName: this.newRole.roleName,
          description: this.newRole.description,
        };
        RolePermissionRequest.duplicateRole(post).then((res) => {
          if (res.data.data) {
            if (res.data.code === 200 && res.data.status === "OK") {
              this.showDialogRole = false;
              this.listAll();
              this.$utilFront.notifications(res.data.data, "SUCCESS");
            } else if (res.data.code === 401) {
              this.unauthorized();
            } else {
              this.$utilFront.notifications(res.data.data, "ERROR");
            }
          }

        }).finally(() => {
          this.sending = false;
        });
      } catch (e) {
        this.catchError(e);
        this.sending = false;
      }
      }
    },

    showModalRole(item) {
      this.newRole = {};
      this.showDialogRole = true;
      this.roleToDuplicate = item;
    },
  },
};
</script>